import React from 'react';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';

import { SyncMeetingsSteps } from '../../types';

import './CreateTeammatesWorkspacesFormFields.scss';

type Props = {
  currentStep: SyncMeetingsSteps;
};

function CreateTeammatesWorkspacesFormFields({ currentStep }: Props) {
  return (
    <div className="CreateTeammatesWorkspacesFormFields d-flex flex-column">
      {currentStep === SyncMeetingsSteps.createNewTeammateWorkspaces && (
        <div>
          The following <b>1:1s</b> were found in your calendar. Select the ones you wish to create a workspace for.
        </div>
      )}
      {currentStep === SyncMeetingsSteps.newOneOnOneMeetings && (
        <div>
          The following <b>1:1s</b> were found in your calendar. Create workspaces for them by selecting from the
          meetings below.
        </div>
      )}
      <div className="CreateTeammatesWorkspacesFormFields__highlight-description mt-3 mb-4">
        Don’t worry we won’t invite them just yet.
      </div>
      <FormRecurringMeetingsSelection
        selector="recurringMeetings"
        type={WorkspaceType.isTeammate}
        label="1:1 Meetings from Calendar"
      />
    </div>
  );
}

export default CreateTeammatesWorkspacesFormFields;
